import { locales, useI18n } from '../lib/i18n';

const names = { en: 'English', gl: 'Galego', pl: 'Polski' } as const;
export function LanguageSelector({ className }: { className?: string }) {
  const { locale, setLocale, t } = useI18n();
  return <div className={className ?? 'language-selector'} role="radiogroup" aria-label={t('language')}>{locales.map((item) => <span key={item} role="radio" tabIndex={locale === item ? 0 : -1} lang={item} aria-checked={locale === item} onClick={() => setLocale(item)} onKeyDown={(event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); setLocale(item); } }}>{names[item]}</span>)}</div>;
}
